<div class="d-flex flex-column h-100">
    <div class="d-flex list-header">
        <h3 class="list-title ">
            {{title()}}
        </h3>

        <rask-alert-list-sort class="ms-auto" (sortChanged)="onSortChanged($event)"></rask-alert-list-sort>
    </div>

    @if(data() | async; as data) {
    <ul class="overflow-auto">
        @for(item of getSortedData(data); track $index) {
        <li [ngClass]="item.cssClass">
            <div class="d-flex">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center gap-2">
                        <i class="far" [ngClass]="{
                            'fa-circle-exclamation text-error': item.severity === 1,
                            'fa-square-exclamation text-warning': item.severity === 2,
                            'fa-info-circle info': item.severity === 4
                            }">
                        </i>
                        @if(iconsTemplate(); as templateRef) {
                        <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: item }"></ng-container>
                        }
                    </div>
                    <div class="d-flex flex-column">
                        @for(link of item.links; track $index) {
                        @if(link.isExternal) {
                        <a
                            [href]="link.resource"
                            target="_blank"
                            [title]="link.title ?? link.text">
                            <span>{{link.text}}</span>
                            <i class="fal fa-external-link-alt ms-1"></i>
                        </a>
                        }
                        @else {
                        <a
                            [routerLink]="[link.resource]"
                            [queryParams]="link.queryParams"
                            [title]="link.title ?? link.text">
                            {{ link.text }}
                        </a>
                        }
                        }
                    </div>
                </div>
                <div class="ms-auto text-end d-flex flex-column">
                    <span>{{item.title}}</span>
                    <span>{{item.message}}</span>
                    @if(item.timestamp) {
                        <span>{{item.timestamp | date:'yyyy-MM-dd'}}</span>
                    }
                </div>
            </div>
            @if(item.description) {
            <div>
                {{item.description}}
            </div>
            }
        </li>
        }
    </ul>
    }
    @else{
    <div class="w-100 h-100 d-flex">
        <rask-busy-spinner size="4" class="m-auto"></rask-busy-spinner>
    </div>
    }
</div>